<div class="knowledge-base">
    <out-carousel timing="250ms ease" [showControls]="true" [showNavigation]="false">
        <ng-container buttonPrev>
            <div class="button--prev">
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#links-open"></use></svg>
            </div>
        </ng-container>
        <ng-container buttonNext>
            <div class="button--next">
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
            </div>
        </ng-container>
        <ng-container items>
            <out-carousel-item
                class="out-carousel-item--highlight"
                *ngFor="let knowledgeBaseItem of knowledgeBaseItems"
            >
                <ng-container *ngIf="knowledgeBaseItem.url">
                    <a routerLink="{{ knowledgeBaseItem.url }}">
                        <ins-card [highlight]="true" [white]="onDark" [verticalAlign]="true">
                            <ins-card-head>
                                <h2 [innerHTML]="knowledgeBaseItem.title | sanitize">"</h2>
                            </ins-card-head>
                            <ins-card-content>
                                <wuc-picture
                                    [imageDesktop]="knowledgeBaseItem.image + '.webp' || knowledgeBaseItem.image + '.png'"
                                    [imageType]="'image/webp' || 'image/png'"
                                    [alt]="knowledgeBaseItem.alt"
                                    [imageWidth]="{ desktop: 147 }"
                                    [imageHeight]="{ desktop: 104 }"
                                ></wuc-picture>
                            </ins-card-content>
                        </ins-card>
                    </a>
                </ng-container>
                <ng-container *ngIf="knowledgeBaseItem.href">
                    <a href="{{ knowledgeBaseItem.href }}">
                        <ins-card [highlight]="true" [white]="onDark" [verticalAlign]="true">
                            <ins-card-head>
                                <h2 [innerHTML]="knowledgeBaseItem.title"></h2>
                            </ins-card-head>
                            <ins-card-content>
                                <wuc-picture
                                    [imageDesktop]="knowledgeBaseItem.image + '.webp' || knowledgeBaseItem.image + '.png'"
                                    [imageType]="'image/webp' || 'image/png'"
                                    [alt]="knowledgeBaseItem.alt"
                                    [imageWidth]="{ desktop: 147 }"
                                    [imageHeight]="{ desktop: 104 }"
                                ></wuc-picture>
                            </ins-card-content>
                        </ins-card>
                    </a>
                </ng-container>
            </out-carousel-item>
        </ng-container>
    </out-carousel>
</div>
